import { useCanvasStore } from "@/store/zustand/canvasStore";
import { useActiveCanvas } from "@/utils/utils";
import { MutableRefObject } from "react";

export const useFullscreenToSize = () => {
  const activeCanvas = useActiveCanvas();
  const setCanvasPosValue = useCanvasStore((store) => store.setCanvasPosValue);

  return (
    canvasContainerRef: MutableRefObject<any>,
    width: number,
    height: number,
    x: number,
    y: number,
    options: {
      fillRatio?: number;
      minScale?: number;
    } = {}
  ) => {
    const { fillRatio, minScale } = options;

    // Calculate center
    const scrollToX = x + width / 2;
    const scrollToY = y + height / 2;

    // Container dimensions
    const containerHeight = canvasContainerRef.current.offsetHeight;
    const containerWidth = canvasContainerRef.current.offsetWidth;

    if (!containerHeight || !containerWidth) {
      return;
    }

    // Scale based on width or height, making sure both fit
    const targetFillRatio = fillRatio || 0.9;
    const scaleForWidth = (containerWidth * targetFillRatio) / width / 0.45;
    const scaleForHeight = (containerHeight * targetFillRatio) / height / 0.45;
    let scale = Math.min(scaleForWidth, scaleForHeight);

    if (minScale) {
      scale = Math.min(scale, minScale);
    }

    // Calculate zoom level and apply
    const zoomLevel = scale;
    // @ts-expect-error TS2345
    setCanvasPosValue(activeCanvas?.id, {
      zoomPerc: zoomLevel,
      transformX: scrollToX,
      transformY: scrollToY,
    });
  };
};
